import { EventType, State, } from '../../graphql/graphql';
import React from 'react';
import { LoadingIndicator } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { StyledTitle } from './MetadataMessage';
import { useTranslation } from 'react-i18next';
import TextDir from '../../lib/TextDir';
export const isMessagingStateEvent = (event) => {
    return (event.type === EventType.MessagingState &&
        event.messagingStateEvent !== null);
};
const AdvisorComposing = styled.div `
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  padding: 2rem 0.7rem 0 0.7rem;
`;
const CustomLoadingIndicator = styled(LoadingIndicator) `
  align-self: center;
  margin-bottom: 0.5rem;
`;
export const MessagingStateMessage = ({ event, }) => {
    const { t, i18n } = useTranslation();
    switch (event.messagingStateEvent.state) {
        case State.AdvisorComposing:
            return (React.createElement(AdvisorComposing, null,
                React.createElement(CustomLoadingIndicator, { indicatorSize: "sm" }),
                React.createElement(StyledTitle, { "data-testid": "advisor-composing", variant: "mesto", semanticColor: "textSubdued", weight: "book", paddingBottom: "0.7rem" },
                    React.createElement(TextDir, { locale: i18n.language }, t('IS_TYPING_TEXT', {
                        advisor_name: event.messagingStateEvent.from,
                    })))));
        default:
            return null;
    }
};
//# sourceMappingURL=MessagingStateMessage.js.map